if (!customElements.get('tb-logo-marquee')) {
  customElements.define('tb-logo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const button = this.querySelector('.tb-logo-marquee__pause');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? 'Resume logos' : 'Pause logos';
      }, { signal: this.events.signal });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
